import api from "./api";

const NOTES_CATEGORY_ID = 4;
const LECTURES_CATEGORY_ID = 3;
const PODCAST_CATEGORY_ID = 12;
const INFOGRAPHICS_CATEGORY_ID = 13;

export async function fetchQuestionBankFilterList(params = {}) {
  const categoryId = Number(params?.category_id || 0);
  const endpoint = categoryId === NOTES_CATEGORY_ID
    ? "/notes/filter-list"
    : categoryId === LECTURES_CATEGORY_ID
    ? "/lectures/filter-list"
    : categoryId === PODCAST_CATEGORY_ID
    ? "/audio-podcast/filter-list"
      : categoryId === INFOGRAPHICS_CATEGORY_ID
        ? "/infographics/filters"
      : "/question-bank/filter-list";

  const response = await api.get(endpoint, {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}
